import { Component, OnInit } from '@angular/core';
import { IndexService, CardSize, CardType } from '../index.service';

@Component({
	selector: 'common-chart',
	templateUrl: './chart.component.html',
	styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
	navSize: CardSize;
	navName = 'chart';

	constructor(public svr: IndexService) {
		this.navSize = this.svr.userSetting.Cards.find(x => x.Type === this.navName).Size;
		console.log(this.navSize);
	}

	ngOnInit() {}
}
